<div class="copon-added-wrapper">
  <div class="img-align">
    <div class="left">
      <img src="assets/icon/Group 566.svg" alt="copon-added">
    </div>
    <div class="right">
      <img src="assets/icon/clear.svg" class="close-icon" alt="close" (click)="close();crossBtnGA()">
    </div>
  </div>
  <div class="copon-added-wrapper2">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="text-center" *ngIf="applycoupon">
            <span *ngIf="data['selectedCouponType']['promoType'] === 'msr-reward';else other_content">
              Success! Your reward has been applied.
            </span>
            <ng-template #other_content> Success! Your offer has been applied.</ng-template>
          </h2>
          <h2 class="text-center" *ngIf="removecoupon">
            <span *ngIf="data['selectedCouponType']['promoType'] === 'msr-reward';else other_content">
              Your reward has been removed.
            </span>
            <ng-template #other_content> Your offer has been removed.
            </ng-template>
          </h2>
          <h2 class="text-center" *ngIf="data === 'mail sent success'">
            Your order details has been shared successfully on your email.
          </h2>
        </div>
        <div class="col-12 text-center mt-4">
          <button *ngIf="data !== 'mail sent success'" type="button" class="custom-btn btn-md-rounded btn-black"
            (click)="applyCopon()">Close</button>
          <button *ngIf="data === 'mail sent success'" type="button" class="custom-btn btn-md-rounded btn-black"
            (click)="close()">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 text-right">
    <img src="assets/icon/Group45.svg" alt="copon-added">
  </div>
</div>
